import CustomField from '../CustomField';
import CustomFieldValue from 'components/framework/models/CustomFieldValue';
import CustomFieldOption from 'components/framework/models/CustomFieldOption';

export default class SelectMultipleField extends CustomField {
  exampleContents() {
    return {
      tags: [{ name: 'Example tag', color: '#666666' }],
    };
  }

  contentsForRecord(record) {
    const customFieldValue = this.customFieldValueForRecord(record);

    if (
      !customFieldValue?.customFieldOptions ||
      customFieldValue.customFieldOptions.length === 0
    ) {
      return {};
    }

    return {
      tags: customFieldValue.customFieldOptions.map(cfo => ({
        name: cfo.name,
        color: cfo.colorObject.hex(),
      })),
    };
  }

  buildScope(query) {
    return query.deepMerge({
      customFieldValues: CustomFieldValue.select('key')
        .merge({
          customFieldOptions: CustomFieldOption.select(
            'name',
            'color',
            'hidden'
          ),
        })
        .argument({
          ids: this.id,
        }),
    });
  }
}
